import React from 'react';
import Icon from '../../../components/AppIcon';
import StyledTable from '../../../components/ui/StyledTable';
import StatusBadge from '../../../components/ui/StatusBadge';
import Button from '../../../components/ui/Button';


const PaymentScheduleTable = ({ payments, loading }) => {
  const formatCurrency = (amount, currency) => {
    const formatted = new Intl.NumberFormat('ar-EG')?.format(amount);
    return `${formatted} ${currency || 'دينار'}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ar-EG', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    })?.format(date);
  };

  const getPaymentStatusBadge = (status) => {
    const statusMap = {
      'paid': {
        label: 'مدفوع',
        color: 'text-success',
        bgColor: 'bg-success/10',
        borderColor: 'border-success/20',
        icon: 'CheckCircle'
      },
      'pending': {
        label: 'معلق',
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        borderColor: 'border-warning/20',
        icon: 'Clock'
      },
      'overdue': {
        label: 'متأخر',
        color: 'text-error',
        bgColor: 'bg-error/10',
        borderColor: 'border-error/20',
        icon: 'AlertCircle'
      }
    };
    return statusMap?.[status] || statusMap?.['pending'];
  };

  if (loading) {
    return (
      <div className="bg-card rounded-lg border border-border p-6">
        <div className="animate-pulse space-y-4">
          <div className="h-4 bg-muted rounded w-1/4"></div>
          <div className="h-10 bg-muted rounded"></div>
          <div className="h-10 bg-muted rounded"></div>
          <div className="h-10 bg-muted rounded"></div>
        </div>
      </div>
    );
  }

  if (!payments || payments?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border p-6 text-center" dir="rtl">
        <Icon name="Receipt" size={40} color="var(--color-muted-foreground)" />
        <p className="text-muted-foreground mt-3">لا توجد دفعات مسجلة</p>
      </div>
    );
  }

  const totalAmount = payments?.reduce((sum, payment) => sum + (payment?.totalAmount || 0), 0);

  const columns = [
    {
      header: 'رقم العقد',
      accessor: 'contractNumber',
      className: 'w-1/5',
      render: (row) => (
        <span className="text-sm font-medium text-foreground">{row?.contractNumber}</span>
      ),
    },
    {
      header: 'العقار',
      accessor: 'propertyTitle',
      className: 'w-1/4',
      render: (row) => (
        <span className="text-sm text-muted-foreground">{row?.propertyTitle}</span>
      ),
    },
    {
      header: 'المبلغ',
      accessor: 'totalAmount',
      className: 'w-1/5',
      render: (row) => (
        <span className="text-sm font-bold text-foreground">
          {formatCurrency(row?.totalAmount, row?.currency)}
        </span>
      ),
    },
    {
      header: 'تاريخ البدء',
      accessor: 'startDate',
      className: 'w-1/5',
      render: (row) => (
        <span className="text-sm text-muted-foreground">{formatDate(row?.startDate)}</span>
      ),
    },
    {
      header: 'الحالة',
      accessor: 'paymentStatus',
      className: 'w-1/6',
      render: (row) => {
        const statusBadge = getPaymentStatusBadge(row?.paymentStatus);
        return (
          <StatusBadge
            status={statusBadge?.variant}
            label={statusBadge?.label}
            icon={statusBadge?.icon}
            className=""
          />
        );
      },
    },
  ];

  return (
    <div className="bg-card rounded-lg border border-border p-4" dir="rtl">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">جدول الدفعات</h3>
        <Button variant="outline" size="sm" iconName="Download">
          تصدير
        </Button>
      </div>

      {/* Table */}
      <StyledTable
        columns={columns}
        data={payments}
        variant="gold"
        emptyMessage="لا توجد دفعات"
        emptyIcon="CreditCard"
        onRowClick={() => {}}
        selectedRow={null}
        onSelectRow={() => {}}
        onSelectAll={() => {}}
        className=""
      />
    </div>
  );
};

export default PaymentScheduleTable;